import React from "react";
import styles from "./css/EnrolledCourseCard.module.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

const deterministicStudentCountFromId = (id) => {
  if (!id || typeof id !== "string") return 0;
  let hash = 5381;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) + hash) + id.charCodeAt(i);
    hash = hash & 0xffffffff;
  }
  const rangeSize = 4000 - 1000 + 1;
  const positive = Math.abs(hash);
  const offset = positive % rangeSize;
  return 1000 + offset;
};

const EnrolledCourseCard = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const count =
    typeof props.studentCount === "number" && props.studentCount >= 1000
      ? props.studentCount
      : deterministicStudentCountFromId(props?.id);

  const handleViewCourse = () => {
    if (props.isActive) {
      history.push({
        pathname: `/course/view/${props?.id}`,
      });
    }
  };

  const getProgressIcon = () => {
    if (props.progress === 0) return "Course-Not-started.svg";
    if (props.progress === 100) return "course-completed.svg";
    return "course-In-progress.svg";
  };

  const getProgressText = () => {
    if (props.progress === 0) return "not started";
    if (props.progress === 100) return "completed";
    return "in progress";
  };

  const getProgressBarClass = () => {
    if (props.progress === 0) return styles.notStarted;
    if (props.progress === 100) return styles.completed;
    return "";
  };

  const getProgressTextClass = () => {
    if (props.progress === 0) return styles.notStarted;
    if (props.progress === 100) return styles.completed;
    return "";
  };

  const enrolledBadgeText = props?.progress === 100 ? "completed" : "enrolled";

  return (
    <div
      className={`${styles.enrolledCourseCardContainer} ${!props.isActive ? styles.disabledCard : ""}`}
      aria-label="Course inactive"
      onClick={handleViewCourse}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleViewCourse()}
      style={{ cursor: props.isActive ? "pointer" : "not-allowed" }}
    >
      <div className={styles.imageContainer}>
        <img src={props?.image} alt="" className={styles.courseImage} />
        <div className={styles.progressBadge}>
          <img
            src={`/Image/lecturePlan/${getProgressIcon()}`}
            alt="progress status"
            className={styles.progressIcon}
          />
        </div>
      </div>

      <div className={styles.contentContainer}>
        <div
          className={styles.badgesWrapper}
          role="group"
          aria-label={props.isActive ? "Enrolled" : "Enrolled, inactive"}
        >
          <div className={styles.enrolledBadge}>
            <span className={styles.enrolledText}>{enrolledBadgeText}</span>
          </div>

          {!props.isActive && (
            <div
              className={styles.inactiveBadge}
              title="This course is currently inactive"
              aria-hidden="false"
              role="status"
            >
              INACTIVE
            </div>
          )}
        </div>

        {props?.isLive && (
          <div className={styles.liveBadgeContainer}>
            <img
              src="/Image/CourseMonetisation/LiveSchedule/Live-badge-cards.svg"
              aria-hidden="true"
              className={styles.liveBadge}
            />
          </div>
        )}
        <div id={styles.courseTitle}>{props?.title}</div>

        <div id={styles.instructor}>
          <div className={styles.instructor_name}>
            <img
              style={{ width: 16, height: 16 }}
              src="/Image/CourseMonetisation/user-2-line.svg"
              alt=""
            />
            <span>{props.instructor ?? ""}</span>
          </div>
        </div>

        <div className={styles.student_count}>
          <img
            style={{ width: 14, height: 14 }}
            src="/Image/CourseMonetisation/student1.svg"
            alt=""
          />
          <span>
            {count > 1
              ? count + ` ${t("courseMonetisation.students")}`
              : count + ` ${t("courseMonetisation.student")}`}
          </span>
        </div>

        <div className={styles.courseLength}>
          <img src="/Image/lecturePlan/info.svg" alt="course length" />
          <span>
            {props.courseLength < 60
              ? `${Math.floor(props.courseLength)} total minutes`
              : `${Math.floor(props.courseLength / 60)} total hours`}
            &nbsp;&#x2022;&nbsp;
          </span>
          <span>
            {props.lectureCount > 1
              ? `${props.lectureCount} ${t("common.lectures")}`
              : `${props.lectureCount} ${t("common.lecture")}`}
          </span>
        </div>

        <div className={styles.progressContainer}>
          <div className={styles.progressBar}>
            <div
              className={`${styles.progressFill} ${getProgressBarClass()}`}
              style={{ width: `${props?.progress || 0}%` }}
            ></div>
          </div>
          <span
            className={`${styles.progressText} ${getProgressTextClass()}`}
          >
            {props?.progress || 0}% {getProgressText()}
          </span>
        </div>

        <div className={styles.actionContainer}>
          <button
            className={styles.publicCourseButton}
            disabled={!props.isActive}
          >
            CONTINUE
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnrolledCourseCard;
